export enum CustomOperationSteps {
  Loading = 'Loading',
  Error = 'Error',
  OperationDetails = 'OperationDetails',
  InstrumentVariationHelperText = 'InstrumentVariationHelperText',
  OperationVariationHelperText = 'OperationVariationHelperText',
  TotalEarningsHelperText = 'totalEarningsHelperText'
}
